module.exports = __webpack_public_path__ + "img/pop-pos2.60035e09.png";